import ToggleSwitch from './ToggleSwitch';

interface ToggleSwitchCardProps {
  label: string;
  name: string;
  checked: boolean;
  onChange: () => void;
  description?: string;
  disabled?: boolean;
  activeColor?: string;
  inactiveColor?: string;
  className?: string;
}

const ToggleSwitchCard = ({
  label,
  name,
  checked,
  onChange,
  description,
  activeColor,
  inactiveColor,
  className = '',
}: ToggleSwitchCardProps) => {
  return (
    <div
      className={`
        rounded-xl
        border
        border-stroke
        bg-gray-2/60
        px-4
        py-4
        shadow-sm
        dark:border-strokedark
        dark:bg-meta-4/40
        ${className}
      `}
    >
      <ToggleSwitch
        label={label}
        name={name}
        checked={checked}
        onChange={onChange}
        activeColor={activeColor}
        inactiveColor={inactiveColor}
      />

      {description && (
        <p className="mt-3 text-xs leading-5 text-bodydark2 dark:text-bodydark">
          {description}
        </p>
      )}
    </div>
  );
};

export default ToggleSwitchCard;